import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '../../_services';
import jwt_decode from 'jwt-decode';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'handle-login',
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
  ],
  template: '<mat-spinner mode="indeterminate"></mat-spinner>'
})

export class HandleLoginComponent implements OnInit {
  constructor(private route: ActivatedRoute,
              private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    this.route.paramMap.subscribe(params => {
      const token = params.get('token'),
        refresh = jwt_decode(token)['refreshToken'];
      this.authenticationService.setActiveToken(token, refresh, returnUrl);
    });
  }
}
